import { useClientTranslation } from '@/lib/core/i18n';
import type { VenueGroupVenueDto } from '@/services/platform/api/model';
import { BookmarkButton } from '../ui/bookmark-button';
import { EyebrowTags } from '../ui/eyebrow-tags';
import { resolveMediaUrl } from '../ui/resolveMediaUrl';

interface VenueCardProps {
  venue: VenueGroupVenueDto;
  isBookmarked: boolean;
  onBookmark: (venue: VenueGroupVenueDto) => void;
  onTap?: (venue: VenueGroupVenueDto) => void;
}

export function VenueCard({ venue, isBookmarked, onBookmark, onTap }: VenueCardProps) {
  const t = useClientTranslation();
  const imageUrl = resolveMediaUrl(venue.image?.url);
  return (
    <div
      className="border-jncquoi-neutral-200 flex flex-col gap-4 border-b pb-4 last:border-0"
      onClick={() => onTap?.(venue)}
      role={onTap ? 'button' : undefined}
      style={onTap ? { cursor: 'pointer' } : undefined}
    >
      {imageUrl && (
        <div className="h-38 w-full overflow-hidden">
          <img src={imageUrl} alt={venue.name ?? ''} className="h-full w-full object-cover" />
        </div>
      )}
      <div className="flex flex-col gap-2">
        <EyebrowTags
          labels={[venue.membersOnly ? t('App.Labels.MembersOnly') : null, venue.serviceCategoryName]}
        />
        <div className="flex items-center gap-4">
          <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 min-w-0 flex-1 overflow-hidden text-[16px] leading-none font-medium tracking-[0.25px] text-ellipsis whitespace-nowrap">
            {venue.name}
            {venue.titleAccent && <span className="ml-2">{venue.titleAccent}</span>}
          </p>
          <BookmarkButton isBookmarked={isBookmarked} onBookmark={() => onBookmark(venue)} />
        </div>
        {venue.description && (
          <p className="font-pp-neue-montreal text-jncquoi-neutral-700 text-[12px] leading-normal tracking-[0.5px]">
            {venue.description}
          </p>
        )}
      </div>
    </div>
  );
}
